// Shared "is this influencer eligible for a live refresh right now" logic —
// used by the per-row Fetch Details button (InfluencerTable.jsx) AND the
// bulk "Refresh All" breakdown (PlanSummary.jsx), so the two can never
// disagree about what counts as eligible/on-cooldown/ineligible.

// Must match REFRESHABLE_PLATFORMS in pluginbackendnode/routes/plans.js —
// kept as a separate constant here (no shared config layer between the two
// repos) so the UI can proactively reflect eligibility instead of waiting on
// a round trip to be rejected.
export const REFRESHABLE_PLATFORMS = ["instagram", "youtube"];

// Must match REFRESH_COOLDOWN_DAYS in pluginbackendnode/routes/plans.js.
export const REFRESH_COOLDOWN_DAYS = 7;
export const REFRESH_COOLDOWN_MS = REFRESH_COOLDOWN_DAYS * 24 * 60 * 60 * 1000;

// True when none of the metrics a live refresh actually fills in have ever
// been populated. Must match hasNoLiveAverages in pluginbackendnode/routes/plans.js
// — lastRefreshedAt gets stamped by several backend flows that never touch
// these fields at all (an extension sync, a Report backfill that only ever
// pulls follower count), so "recently touched" doesn't mean "recently got
// real averages." A row stuck on "—" for every metric has no fresh data to
// protect, so it should never be cooldown-blocked.
const hasNoLiveAverages = (influencer) =>
  influencer.viewsAvg == null &&
  influencer.likesAvg == null &&
  influencer.commentsAvg == null &&
  influencer.repostsAvg == null &&
  influencer.engagementRate == null;

export const getCooldownInfo = (influencer) => {
  if (!influencer.lastRefreshedAt || hasNoLiveAverages(influencer)) return null;
  const lastRefreshedTime = new Date(influencer.lastRefreshedAt).getTime();
  if (Date.now() - lastRefreshedTime >= REFRESH_COOLDOWN_MS) return null;
  return {
    lastRefreshedAt: influencer.lastRefreshedAt,
    nextEligibleAt: new Date(lastRefreshedTime + REFRESH_COOLDOWN_MS),
  };
};

export const canRefreshInfluencer = (influencer) =>
  Boolean(influencer.rapidInfluencerId) && REFRESHABLE_PLATFORMS.includes(influencer.platform);
